import { Button, ResultPage } from "antd-mobile"
import { useCallback, useEffect, useState } from "react"
import { DIETA } from "../../api/dieta"
import { randomInteger } from "../../utils/random"

function Dieta() {
  const [recipe, setRecipe] = useState({})
  useEffect(() => {
    setRecipe(DIETA[0])
  }, [])

  const onUpdate = useCallback(() => {
    setRecipe(DIETA[randomInteger(0, DIETA.length - 1)])
  }, [])

  return (
    <ResultPage
      status="success"
      title={recipe.name}
      description="Исходя из вашей дневной нормы, мы подобрали вам рецепт"
    >
      <div style={{ height: "calc(100vh - 300px)" }}>
        <div
          style={{
            borderRadius: 8,
            background: "white",
            padding: 12,
            marginBottom: 16,
          }}
        >
          <p>{recipe.ingredients}</p>
        </div>
        {recipe?.steps?.map((item) => {
          return (
            <div key={item.id}>
              <div
                style={{
                  backgroundImage: `url('${item.image}')`,
                  width: "100%",
                  height: 240,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  display: "flex",
                  flexDirection: "column-reverse",
                }}
              ></div>
              <div
                style={{
                  borderRadius: 8,
                  background: "white",
                  padding: 12,
                  marginTop: 16,
                  marginBottom: 16,
                }}
              >
                <p>{item.description}</p>
              </div>
            </div>
          )
        })}
        <div style={{ paddingTop: 30, paddingBottom: 60 }}>
          <Button
            block
            color="success"
            fill="outline"
            size="large"
            onClick={onUpdate}
          >
            Загрузить другой рецепт
          </Button>
        </div>
      </div>
    </ResultPage>
  )
}

export default Dieta
